@if (progress && shouldShow) {
  <div class="ref-strip" role="status" [attr.aria-live]="isLoading ? 'polite' : null" [attr.aria-label]="statusMessage + '. ' + (isLoading ? 'This can take up to a few minutes.' : '')">
    <div class="ref-strip__row">
      @if (isLoading) {
        <mat-spinner class="ref-strip__spinner" [diameter]="18" [strokeWidth]="2" aria-hidden="true"></mat-spinner>
      }
      <span class="ref-strip__text">{{ statusMessage }}</span>
      @if (showProgressBar && progressLabel) {
        <span class="ref-strip__count">{{ progressLabel }}</span>
      }
    </div>
    @if (isLoading) {
      <p class="ref-strip__hint">This can take up to a few minutes. You can keep reading the response below.</p>
    }
    @if (showProgressBar) {
      <div class="ref-strip__bar" role="progressbar" [attr.aria-valuenow]="progressPercent" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuetext]="progressLabel">
        <div class="ref-strip__bar-fill" [style.width.%]="progressPercent"></div>
      </div>
    }
  </div>
}
